import { isTreeItem, ReservedNodeType, TreeNode } from '@morph-mapper/types';

/**
 * This hook is used for filtering the rules in the diff selector on an
 * updat domain, it removes all segments from the textcontent and textcontentsync
 * to only display relevant fields
 */

const getEntryPathSegments = (
  entries: Record<string, TreeNode>,
  id: string,
): string[] => {
  const segments: string[] = [];
  let currentId: string | undefined = id;

  while (currentId !== undefined) {
    const current: TreeNode | undefined = entries[currentId];
    if (!current || current.parentId === undefined) break;

    segments.unshift(current.key);
    currentId = current.parentId;
  }

  return segments;
};

export const getDocFieldPaths = (
  entries: Record<string, TreeNode>,
): string[] => {
  const paths = new Set<string>();

  Object.values(entries)
    .filter(isTreeItem)
    .forEach((entry) => {
      const segments = getEntryPathSegments(entries, entry.id);
      if (segments.includes(ReservedNodeType.DeclareVariable)) return;

      const docIndex = segments.indexOf('doc');
      if (docIndex === -1) return;

      const path = segments.slice(docIndex + 1).join('.');
      if (path) paths.add(path);
    });

  return Array.from(paths);
};

function buildFieldTree(fieldPaths: string[]) {
  const root: any = {};

  for (const fieldPath of fieldPaths) {
    const parts = fieldPath.split('.');

    let node = root;
    for (const part of parts) {
      if (!node[part]) node[part] = {};
      node = node[part];
    }
  }

  return root;
}

function filterByTree(data: any, tree: any): any {
  if (Array.isArray(data)) {
    const arr = [];
    for (const item of data) {
      arr.push(filterByTree(item, tree));
    }
    return arr;
  }

  if (data !== null && typeof data === 'object') {
    const keys = Object.keys(tree);
    if (keys.length === 0) {
      return data;
    }

    const result: any = {};
    for (const key of keys) {
      if (key in data) {
        result[key] = filterByTree(data[key], tree[key]);
      }
    }
    return result;
  }

  return data;
}

export function filterByFieldPaths(value: unknown, fieldPaths: string[]) {
  if (fieldPaths.length === 0) return value;

  const tree = buildFieldTree(fieldPaths);
  return filterByTree(value, tree);
}
